module.exports = __webpack_public_path__ + "img/id-button.7f99d4b4.png";